const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/dashboard/api-factory');
const serviceFactory = require('../resources/dashboard/service-factory');

function addRoutes({ requestHandler } = {}) {
    const api = apiFactory({
        requestHandler,
        baseUrl: `${config.baseUrl}/portfoliooverview/${apiConfig.apiversion}/`
    });

    const service = serviceFactory({ api });
    const p = '[{keys:metaData}].';

    return app => app
    .match((`${p}portfolio.getSummaryPageData[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getPortfolioSummary(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))
    
        .match((`${p}portfolio.getDashboardPageData[{keys:inputParam}]`), requests => Promise.all(
            requests.map(({ req, res }) =>
              service.getPortfolioSummary(req.params)
                .then(response => res.value(response))
                .catch(res.error)
            )))    
}

module.exports = addRoutes;